var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArAgingSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20a4 4 0 0 0-4 4v4.97a4 4 0 0 0 1.675 3.256L36.559 40l-10.884 7.774A4 4 0 0 0 24 51.03V56a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4v-4.97a4 4 0 0 0-1.675-3.256L43.441 40l10.884-7.774A4 4 0 0 0 56 28.97V24a4 4 0 0 0-4-4H28Z",
    fill: "#006C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55.154a.845.845 0 0 1-.846.845H32.846a.845.845 0 0 1-.845-.845 2 2 0 0 1 1-1.732l5-2.888a4 4 0 0 1 4 0l5 2.888a2 2 0 0 1 1 1.732Z",
    fill: "#A0C9BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArAgingSummary);
export default __webpack_public_path__ + "static/media/ar-aging-summary.41f0ad1a.svg";
export { ForwardRef as ReactComponent };